import React from 'react';

const VariationBadge = ({ value, inverted = false }) => {
  if (value == null) return null;

  const isPositive = inverted ? value < 0 : value >= 0;
  const color = isPositive ? '#16a34a' : '#dc2626';
  const bg = isPositive ? '#f0fdf4' : '#fef2f2';

  return (
    <span
      style={{
        fontSize: '0.7rem',
        fontWeight: 600,
        color,
        backgroundColor: bg,
        padding: '1px 6px',
        borderRadius: '4px',
        marginTop: '2px',
      }}
    >
      {value >= 0 ? '+' : ''}
      {value.toFixed(1)}%
    </span>
  );
};

export default VariationBadge;
